<template>
  <div class="main">
    <div class="bg">
        <div class="logo"></div>
        <div class="title"></div>
        <h1>{{ data.duration_time2 }}</h1>
        <div class="btn" @click="appdown"></div>
    </div>

    <div class="content">

        <div class="reward_image" v-if="data.reward_image">
            <img :src="data.reward_image" alt="" style="width: 100%;height: auto;">
        </div>
        
        <div class="wrap2" v-if="data.rank_list && data.rank_list.length > 0">
            <h1>大赛实时排名</h1>

            <div class="h2" v-if="0">
                <img src="../../../assets/images/simustock/li.png"/>
                <img class="gold" src="../../../assets/images/simustock/gold.png" alt="">
                <span>本期奖池：{{data.total_amount}}</span>
                <img src="../../../assets/images/simustock/ri.png" alt="">
            </div>


            <div class="table">

                <div class="t_wrap t_header">
                    <div>排名</div>
                    
                    <div class="min">总收益率</div>

                    <div class="min">持仓</div>
                </div>

                <div class="t_item t_wrap" v-for="(item,i) in data.rank_list" :key="item.id" @click="appdown()">

                    <div class="t_person">
                        <div class="t_img">

                            <img :src="item.user_info.avatar" alt="">
                            <div class="t_no" :class="['t_no'+i]">No.{{ i+1 }}</div>

                        </div>
                        <div class="t_name">{{item.user_info.nickname}}</div>
                    </div>

                    <div class="t_profit min">{{ item.match_profit_rate }}%</div>

                    <div class="t_percent min">
                        <span>看持仓</span>
                    </div>
                    
                </div>

                <div class="more_link">
                    <span @click="appdown()">查看更多排行</span>
                </div>

            </div>


        </div>

        <join></join>
        <word></word>
        <discussion-board></discussion-board>
    </div>

  </div>
</template>

<script>
import Api from "@/api/simulatedStock/index";
import discussionBoard from "./components/discussionBoard.vue";
import join from "./components/join.vue";
import word from "./components/word.vue";

import "@/utils/flexible";
export default {
    components:{
        discussionBoard,
        join,
        word
    },
    data() {
        return {
            data:{},
        };
    },

    created() {
        this.stockDetail();
        
    },
    methods: {
        async stockDetail() {
            const res = await Api.stockDetail({
                source:'mobile',
            });
            console.log(res,'res');
            if(res.rank_list.length > 3) res.rank_list = res.rank_list.slice(0,3);
            this.data = res;
            this.getshare(res.share_data);
        },
        appdown(){
            location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui`;
        },
        async getshare(share_data1) {
            let params = {};
            if(this.$route.query.share_id){
                params.share_id = this.$route.query.share_id;
            }
            let data = await Api.getShare(params);
            let share_data = {
                share_content :share_data1.content,
                share_link :data.share_link,
                share_logo:share_data1.image,
                share_title:share_data1.title,
                share_title_qq:share_data1.title,
                share_title_wx:share_data1.title,
                share_open:{
                    AppID:data.AppID,
                    nonceStr:data.nonceStr,
                    signature:data.signature,
                    timestamp:data.timestamp,
                    share_link :data.share_link,
                }
            }
            console.log(share_data)
            this.$share(share_data);
        },
        pageTo(item){
            // 旧 https://apisbeta.aigupiao.com/HsReplicaProfits/index/?u_id=718288
            location.href = `/up/HsReplicaProfits?m_u_id=${item.u_id}`;
        }
    },
};
</script>

<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";
    .main{
        background: #DE3C14;
        min-height: 100vh;
        overflow: auto;
        padding-bottom: rem(60px);
        .bg{
            background: url(../../../assets/images/simustock/bg.png) no-repeat;
            background-size: cover;
            height: rem(686px);
            width: rem(750px);
            margin: 0 auto;
            .logo{
                background: url(../../../assets/images/simustock/logo.png) no-repeat;
                background-size: 100%;
                height: rem(53px);
                width: rem(155px);
                margin: rem(22px) rem(26px) 0;
            }

            .title{
                background: url(../../../assets/images/simustock/title.png) no-repeat;
                background-size: 100%;
                height: rem(140px);
                width: rem(386px);
                margin: 0 auto ;
            }

            .btn{
                background: url(../../../assets/images/simustock/btn.png) no-repeat;
                background-size: 100%;
                height: rem(126px);
                width: rem(488px);
                margin: 0 auto ;
            }

            >h1{
                height: rem(40px);
                font-size: rem(28px);
                font-weight: 400;
                color: #FFDFC4;
                line-height: rem(40px);
                margin: rem(23px) auto rem(274px);
                text-align: center;
            }
        }


        .content{
            margin: 0 rem(24px);
        }
        

        .reward_image{
            margin-bottom: rem(25px);
        }
        .wrap2{
            background: #FFFFFF;
            border-radius: rem(20px);
            padding: rem(35px) rem(24px) ;

            >h1{
                font-size: rem(32px);
                text-align: center;
                font-weight: 600;
                color: #333333;
                line-height: rem(45px);
                margin-bottom: rem(26px);
            }

            .h2{
                display: flex;
                align-items: center;

                height: rem(42px);
                font-size: rem(30px);
                font-weight: 500;
                color: #E73E13;
                line-height: rem(42px);
                justify-content: center;
                >img{
                    height: rem(4px);
                }
                .gold{
                    height: rem(42px);
                    margin-left: rem(12px);
                    margin-right: rem(8px);
                }
                >span{
                    margin-right: rem(13px);
                }
            }

            .table{

                .t_wrap{
                    display: flex;
                    >div{
                        text-align: center;
                        flex: 1;
                        &.min{
                            flex: 0.5;
                        }
                    }
                }
                .t_header{

                    font-size: rem(24px);
                    font-weight: 400;
                    color: #999999;
                    line-height: rem(94px);
                }
                .t_item{
                   
                    height: rem(141px);
                    border-radius: rem(27px);
                    position: relative;
                    margin-bottom: rem(34px);
                    background: linear-gradient(270deg, rgba(255, 250, 245, .67) 0%, rgba(255, 243, 230, .67) 100%);

                    .t_person{
                        display: flex;
                        align-items: center;
                        .t_img{
                            margin: 0 rem(20px);
                            width: rem(96px);
                            height: rem(96px);
                            border: 2px solid #FF9422;
                            border-radius: 50%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            >img{
                                width: rem(84px);
                                height: rem(84px);
                                border-radius: 50%;
                            }
                            .t_no{
                                bottom: rem(-7px);
                                position: absolute;
                                width: rem(84px);
                                height: rem(34px);
                                background: linear-gradient(270deg, #FFC647 0%, #FF9422 100%);
                                border-radius:  rem(17px);
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                color: #FFFFFF;
                                font-size: rem(20px);
                                &.t_no0{
                                    background: linear-gradient(270deg, rgba(255, 150, 86, 1) 0%, rgba(255, 93, 43, 1) 100%);
                                }
                                &.t_no1{
                                    background: linear-gradient(270deg, rgba(255, 198, 71, 1) 0%, rgba(255, 148, 34, 1) 100%);
                                }
                            }

                        }

                        .t_name{
                            color: #222222;
                            font-size: rem(30px);
                            max-width: 25vw;
                            white-space: nowrap;
                            word-break: break-all;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }

                    .t_profit{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: rem(30px);
                        font-weight: 400;
                        color: #EF0501;
                        line-height: 34px;
                    }

                    .t_percent{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        >span{
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: rem(24px);
                            color: #F20000;
                            padding: 0 rem(18px);
                            height: rem(48px);
                            background: #FEF2F2;
                            border-radius: rem(24px);
                            border: rem(1px) solid rgba(255,71,71,0.05);
                        }

                    }
                }
            }

            .more_link{
                text-align: center;
                padding-top: rem(30px);
                border-top: 2px solid #eee;
                font-size: rem(28px);
                color: #AEAEAE;


                >span{
                    padding-right: rem(20px);
                    background: url(../../../assets/images/simustock/m_i.png) no-repeat;
                    background-size: rem(10px) rem(18px);
                    background-position: right center;
                }
            }
        }
    }
</style>
